import { render, staticRenderFns } from "./agentApprove.vue?vue&type=template&id=07822c16&scoped=true"
import script from "./agentApprove.vue?vue&type=script&lang=js"
export * from "./agentApprove.vue?vue&type=script&lang=js"
import style0 from "./agentApprove.vue?vue&type=style&index=0&id=07822c16&prod&scoped=true&lang=css"
import style1 from "./agentApprove.vue?vue&type=style&index=1&id=07822c16&prod&lang=css"
import style2 from "./agentApprove.vue?vue&type=style&index=2&id=07822c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07822c16",
  null
  
)

export default component.exports